import effects from 'redux-effects'
import cookie from 'redux-effects-cookie'
import localStorage from 'redux-effects-localstorage'
import { get } from 'lodash'

export default [effects, cookie(), localStorage(get(window, 'localStorage'))]
